import { GroupsApi } from "../../api-machine-statistics";
import { APIOptionsWithoutAPIClass, useAPI } from "./useAPI";

export const useGroupsAPI = <T>({
  initialValue,
  handleRequest,
}: APIOptionsWithoutAPIClass<T, GroupsApi>) => {
  return useAPI<T, GroupsApi>({
    initialValue,
    APIClass: GroupsApi,
    handleRequest,
  });
};
